import * as Yup from "yup";
import formData from "./formData";

const {
    formField: { dueDate, vessel, assignee, rating, trainingLocation }
} = formData;

const validationSchema = Yup.object().shape({
    [dueDate.name]: Yup.string()
        .required(`${dueDate.requiredErrorMessage}`),
    [vessel.name]: Yup.object()
        .nullable(true)
        .required(`${vessel.requiredErrorMessage}`),
    [assignee.name]: Yup.object()
        .nullable(true)
        .required(`${assignee.requiredErrorMessage}`),
    [rating.name]: Yup.string()
        .nullable(true)
        .required(`${rating.requiredErrorMessage}`),
    [trainingLocation.name]: Yup.object()
        .nullable(true)
        .required(`${trainingLocation.requiredErrorMessage}`),
});

export default validationSchema;